import { ReactNode } from 'react';

export enum Directions {
    Default = 'default',
    Reverse = 'reverse',
}

export interface Props {
    direction?: Directions;
    leftCol: ReactNode;
    rightCol: ReactNode;
}